// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"WT-z","inlineTitle":"XT-z","sponsoredAdsWrapper":"YT-z","marketplaceRecosWrapper":"ZT-z"};